export default __webpack_public_path__ + "static/media/DEVbanner.7d3274fd.png";